const services = [
  {
    title: '図面画像のCADデータ（DXF）変換',
    description: '紙図面・スキャン画像・竣工図をCADで編集できるDXFへ変換。「改修したいのに竣工図が紙しかない」にも対応。Webサービス「Image2DXF」として稼働中。',
    link: 'https://image2dxf.engimind.jp/'
  },
  {
    title: '数量拾い出し・積算の自動化',
    description: '図面から数量を拾う作業をAIで自動化。属人化した積算・見積りのロジックを標準化し、誰でも同じ根拠で拾える仕組みにします。'
  },
  {
    title: '工事写真の自動整理',
    description: '黒板情報の読み取り・工種別の自動分類・台帳作成をAIで。現場監督の残業の定番原因である写真整理から現場を解放します。'
  },
  {
    title: '点検報告書の自動化',
    description: '橋梁・プラント等の点検写真からひび割れ・腐食をAIが検出し、報告書のドラフトまで自動作成。点検後の書類仕事を大幅に短縮します。'
  },
  {
    title: '安全書類・施工計画書の作成支援',
    description: 'グリーンファイル等の定型書類をAIでドラフト作成。過去の書類と現場情報から下書きを自動生成し、確認・仕上げだけに集中できます。'
  },
  {
    title: '紙帳票・作業記録のデジタル化',
    description: '日報・検査帳票をOCRで自動データ化。転記をなくし、蓄積データを改善に使える形にします。'
  },
  {
    title: '生産・品質データの可視化・分析',
    description: '散在するデータを統合しダッシュボード化。不良傾向の把握と対策判断を速くします。'
  },
  {
    title: '電気工事・設計事務所・測量なども',
    description: '電気工事・設備工事業（見積り・図面）、建築設計事務所（申請書類）、測量・検査会社など。上記サービスの応用で対応できます。'
  }
];

export default function Solution() {
  return (
    <section className="doc" id="service">
      <div className="sheet">
        <p className="sec-label mono">SEC. 02 — 提供サービス</p>
        <h2>図面・計算・ノウハウを、仕組みに変える</h2>
        <p className="sec-intro">主軸は「設計計算・見積り計算の自動化」。図面・写真・帳票まわりの課題もあわせて解決します。対象は製造業・建設業、およびその周辺業種です。</p>

        <div className="svc-main">
          <div>
            <span className="svc-tag">主力サービス</span>
            <h3>設計計算・見積り計算のアプリ化</h3>
            <p>
              属人化したExcel計算表を、入力チェック・計算根拠の表示・帳票出力まで備えたWebアプリに作り替えます。
              計算ロジックの棚卸しと標準化から着手するので、「なぜこの式なのか」が会社の資産として残ります。
              製造業の設計計算だけでなく、建設業の構造計算・仮設計算（足場・揚重計画など）にも対応。
              オープンソースCAE（FEM）を組み込んだ、年間ライセンス費のかからない解析環境の構築も可能です。
            </p>
          </div>
          <div className="flow-diagram mono" aria-label="変換の流れ">
            <div className="flow-node"><span>秘伝のExcel計算表</span><span className="st">属人・根拠不明</span></div>
            <div className="flow-arrow" aria-hidden="true">▼ ロジック棚卸し・標準化</div>
            <div className="flow-node"><span>計算Webアプリ</span><span className="st">全員が使える・根拠付き</span></div>
            <div className="flow-arrow" aria-hidden="true">▼ 必要に応じて</div>
            <div className="flow-node"><span>オープンソースCAE連携</span><span className="st">ライセンス費 ¥0</span></div>
          </div>
        </div>

        <div className="svc-sub">
          {services.map((service) => (
            <div className="svc-card" key={service.title}>
              <h3>{service.title}</h3>
              <p>
                {service.description}
                {service.link && (
                  <>
                    {' '}
                    <a href={service.link} target="_blank" rel="noopener noreferrer">
                      {service.link.replace('https://', '').replace(/\/$/, '')} →
                    </a>
                  </>
                )}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
